<template>
  <section class="wrapper">
    <div class="logo"><img src="../../assets/img/wc-erp-logo.png" alt=""></div>
    <h1 class="title">登录网书智能ERP系统</h1>
    <van-tabs line-height="1" shrink>
      <van-tab title="账号密码登录">
        <van-form class="mt10" @submit="login">
          <van-field
            v-model="loginForm.loginName"
            label="用户名"
            placeholder="用户名"
            :rules="[{ required: true, message: '请填写用户名' }]"
          />
          <van-field
            class="mt10"
            v-model="loginForm.passWd"
            type="password"
            name="密码"
            label="密码"
            placeholder="密码"
            :rules="[{ required: true, message: '请填写密码' }]"
          />
          <van-field
            class="mt10"
            v-model="loginForm.validate"
            name="验证码"
            label="验证码"
            placeholder="验证码"
            :rules="[{ required: true, message: '请填写验证码' }]"
          >
            <template #button>
              <van-image width="56" :src="validateCodeImgUrl" @click="desCodeSend"/>
            </template>
          </van-field>
          <div style="margin: 16px;">
            <van-button block type="primary" native-type="submit">确认登录</van-button>
          </div>
        </van-form>
      </van-tab>
    </van-tabs>
  </section>
</template>

<script>
import {getValidCodeFun, getValidateCodeFun} from '@/api/common'
import {weChatLoginApi, bindPhoneOrEmailApi} from '@/api/login'
import {getUrlParam} from "@/utils/utitiles"

export default {
  name: "bindingcon",
  data() {
    return {
      checked: true,
      validateCodeImgUrl: '',//验证码图片地址
      loginForm: {
        loginName: '',
        passWd: '',
        validate: '',
        DESEncryptValidCode: ''
      },
    }
  },
  //加载完成后有变化时
  mounted() {
    this.desCodeSend();
  },
  methods: {
    //获取加密的验证码,有了这个码才可以请求图片验证码
    async desCodeSend() {
      let response = await getValidCodeFun();
      if (response.success) {
        this.loginForm.DESEncryptValidCode = response.result;
        this.getValidateCode(response.result)
      }
    },
    //获取验证码图片
    async getValidateCode(code) {
      const params = {
        code
      };
      let response = await getValidateCodeFun(params);
      if (response.success) {
        const bufferUrl = btoa(new Uint8Array(response.data).reduce((data, byte) => data + String.fromCharCode(byte), ''));
        this.validateCodeImgUrl = 'data:image/png;base64,' + bufferUrl;
      }
    },
    //点击登录与微信信息绑定
    async login() {
      let params = {
        isLogin:true,
        loginName:this.loginForm.loginName,
        password:this.loginForm.passWd,
        validateCode:this.loginForm.validate,
        desEncryptValidCode:this.loginForm.DESEncryptValidCode,
        openId:sessionStorage.getItem('openid'),
        unionId:sessionStorage.getItem('unionid'),
        nickName:sessionStorage.getItem('nickname'),
        area:sessionStorage.getItem('area'),
        headimgUrl:sessionStorage.getItem('headimgurl'),
        sex:sessionStorage.getItem('sex')
      };
      let response = await bindPhoneOrEmailApi(params);
      if (response.success) {
        if (response.code === "0000") {
          this.setCookie("UserInfo", {
            U_GUID: response.result.U_GUID,
            LoginName: response.result.LoginName,
            TelName: response.result.TelName,
            NickName: response.result.NickName,
            FirstName:response.result.FirstName,
            LastName:response.result.LastName
          });
          this.$router.push({path: '/company'});
          return;
        }
        this.$toast.fail(response.msg);
        await this.desCodeSend();
        return;
      }
    },
  },
}
</script>

<style lang="less" scoped>
  .wrapper {
    background: white;

    .logo {
      padding: 1rem;

      img {
        width: 70%;
      }
    }

    .title {
      text-align: center;
      padding: 2rem 0;
      background: white;
    }

    .info {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      font-size: 1.4rem;
      padding: 0 1rem;
      color: #ccc;
      height: 2rem;
      line-height: 2rem;

      .link {
        color: #00a1bb;
        display: inline-block;
      }
    }

    ::v-deep.van-tab--active {
      flex: .3;
    }

    ::v-deep.van-tabs__line {
      width: 6rem;
    }

    ::v-deep.van-button {
      background: #1fb1c4
    }
  }
</style>
